var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "collection-category-images" }, [
    _c("h5", { class: _vm.$mq === "mobile" ? "h4" : "" }, [
      _vm._v(_vm._s(_vm.categoryImages.heading))
    ]),
    _c(
      "div",
      { staticClass: "collection-category-images__block-container" },
      _vm._l(_vm.categoryImages.images, function(image, index) {
        return _c(
          "a",
          {
            key: index,
            staticClass: "collection-category-images__block bg-white",
            attrs: { href: image.url }
          },
          [
            _c("img", {
              staticClass: "collection-category-images__image",
              attrs: { src: image.imageUrl }
            }),
            _c("span", [_vm._v(_vm._s(image.text))])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }